<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-06-11 09:47:19
 * @LastEditors: voanit
 * @LastEditTime: 2021-07-28 09:56:11
-->
<template>
  <div class="z-number-range" :style="{width: width}">
    <el-input-number 
      v-model="value[startKey]"
      controls-position="right"
      :placeholder="startPlaceholder" />
    <span class="z-number-range__split">~</span>
    <el-input-number 
      v-model="value[endKey]" 
      controls-position="right"
      :placeholder="endPlaceholder" />
  </div>
</template>
<script>
export default {
  name: 'ZNumberRange',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    value: {},
    startKey: {
      type: String,
      required: true
    },
    endKey: {
      type: String,
      required: true
    },
    startPlaceholder: {
      type: String,
      default: '请输入'
    },
    endPlaceholder: {
      type: String,
      default: '请输入'
    }
  },
  data() {
    return {
    }
  },
  watch: {
    
  },
  computed: {
    
  }
}
</script>
<style lang="scss" scoped>
.z-number-range {
  display: flex;
  &__split {
    padding: 0 5px;
    color: #666;
  }
}
</style>
